import React, { useState } from 'react'

import _ from 'lodash'
import { getTemplateDropDownPessoa } from '../../utils/Template'
import { Filtro } from '../../utils/Filtro'
import { icons, routes } from '../../constants'
import apiService from '../../services/api.service'
import { Column } from 'primereact/column'
import { Dialog } from 'primereact/dialog'
import { PessoaFisicaFormPage } from '../../pages/pessoaFisica'
import { Button } from 'primereact/button'
import LtsLookup from './lts-lookup'
import '../../index.scss'
import { InputText } from 'primereact/inputtext'
import { getFiltroJoinUnidade } from '../../utils/filter-utils'

/**
 * FIXME -->> Deprecated - usar LtsLookupPessoa
 */
/**
 * TODO list
 * 1) Ao clicar em 'AddNew' no momento exibimos a tela de PF. Vamos dar opcao de escolher
 * entre PF e PJ antes de exibir a tela?
 *
 */
export default function LtsLookupResponsavel(props) {
  const [filters, setFilters] = useState([])
  const [showDialogAddNew, setShowDialogAddNew] = useState(false)

  const columns = [
    {
      field: 'oid',
      header: 'Código',
      columnKey: 'oid',
      sortable: false,
      filter: true,
    },
    {
      field: 'numeroDocumento',
      header: 'CPF/CNPJ',
      columnKey: 'numeroDocumento',
      sortable: true,
      filter: true,
    },
    {
      field: 'nome',
      header: 'Nome',
      columnKey: 'nome',
      sortable: true,
      filter: true,
    },
    {
      field: 'nomeFantasia',
      header: 'Nome fantasia',
      columnKey: 'nomeFantasia',
      sortable: true,
      filter: true,
    },
  ]

  const loadDataFn = (params) => {
    return apiService.post('/lottustech/pessoas/all', params)
  }

  const onKeyPress = (e) => {
    const idValue = _.get(props, 'value', null)
    if (idValue) {
      const value = typeof idValue === 'string' ? idValue : _.get(idValue, 'value', null)
      const filters = [
        new Filtro('nome', value, 'CONTEM'),
        new Filtro('numeroDocumento', value, 'CONTEM'),
        new Filtro('nomeFantasia', value, 'CONTEM'),
      ]
      const filter = {
        campo: 'filtro',
        valor: filters,
        tipoFiltro: 'OU',
      }
      setFilters([filter])
    }
  }

  const onInputFilter = (e) => {
    const value = e.value
    if (typeof value === 'string') {
      props.onChange({ nome: e.value, oid: null })
    } else {
      props.onChange(value)
    }
  }

  const onResolvingColumn = () => {
    return columns
      .filter((col) => col.field === 'numeroDocumento' || col.field === 'nome' || col.field === 'nomeFantasia')
      .map((col) => {
        // Remove props that should not be spread to DOM elements
        const { showFilterMenuOptions, showClearButton, showFilterMenu, ...columnProps } = col

        if (col.field === 'numeroDocumento') {
          return (
            <Column
              {...columnProps}
              key={col.field}
              bodyClassName="column-nr-documento-body-width"
              filterHeaderClassName="column-nr-documento-filter-header-width"
              headerClassName="column-nr-documento-header-width"
              filterElement={columnFilterElement(col)}
            />
          )
        }
        if (col.field === 'nome') {
          return (
            <Column
              {...columnProps}
              key={col.field}
              bodyClassName="column-nome-pessoa-body-width"
              filterHeaderClassName="column-nome-pessoa-filter-header-width"
              headerClassName="column-nome-pessoa-header-width"
              filterElement={columnFilterElement(col)}
            />
          )
        }
        if (col.field === 'nomeFantasia') {
          return (
            <Column
              {...columnProps}
              key={col.field}
              bodyClassName="column-nome-pessoa-body-width"
              filterHeaderClassName="column-nome-pessoa-filter-header-width"
              headerClassName="column-nome-pessoa-header-width"
              filterElement={columnFilterElement(col)}
            />
          )
        }
        return null
      })
  }

  const columnFilterElement = (column) => {
    return <InputText style={{ width: '100%' }} name={column.field} onChange={(e) => onChangeTableFilter(column, e)} />
  }

  const onChangeTableFilter = (column, e) => {
    const campo = column.field

    //remove o filtro do campo atual com valor 'antigo'
    const newFilters = filters.filter((f) => f.campo !== campo)

    const valor = _.get(e, 'target.value', null)
    if (valor) {
      const tipoFiltro = campo === 'oid' ? 'IGUAL_A' : 'CONTEM'
      newFilters.push({ campo, valor, tipoFiltro })
    }

    setFilters(newFilters)
  }

  const resolveFilters = (filters) => {
    const filtroUnidade = getFiltroJoinUnidade(_.get(props, 'idUnidade', null))
    if (filtroUnidade) {
      filters.push(filtroUnidade)
    }
    return filters
  }

  const onClickAddButton = () => {
    setShowDialogAddNew(true)
  }

  const onHideDialogAddNew = () => {
    setShowDialogAddNew(false)
  }

  const getDialogAddNew = () => {
    const footer = (
      <div>
        <Button
          label={'Adicionar'}
          onClick={(e) => onConfirmAddNew(e)}
          icon={icons.PLUS_ICON}
          className="p-button-success"
        />
      </div>
    )

    return (
      <Dialog
        header={'Responsável'}
        visible={showDialogAddNew}
        onHide={onHideDialogAddNew}
        modal={true}
        closable={true}
        style={{ width: '70%' }}
        contentStyle={{ maxHeight: '85%', overflow: 'auto' }}
        footer={footer}
      >
        <React.Fragment>
          <PessoaFisicaFormPage renderToolbar={false} />
        </React.Fragment>
      </Dialog>
    )
  }

  const onConfirmAddNew = (e) => {
    e.preventDefault()
    e.stopPropagation()
    // this.props.adicionarPessoaFisicaResponsavel();
    // this.props.showForm("responsavel", false);
    const responsavel = props.statePessoaFisica.currentRecord
    const nome = _.get(responsavel, 'nome', null)
    if (nome) {
      const tipoChavePix = responsavel.tipoChavePix
      if (tipoChavePix) {
        responsavel.tipoChavePix = tipoChavePix.id
      }
      apiService
        .post(`/lottustech/pessoasfisicas/`, responsavel)
        .then((response) => {
          const nome = _.get(response, 'data.nome', null)
          const oid = _.get(response, 'data.oid', null)
          props.onChange({ nome, oid })
        })
        .catch((error) => {
          /*
                     if (err.response) {
                        const messages = err.response.data;
                        dispatch(messageActions.messageShowMessages(makeMessages([messages], "error")));
                     }
                    */
        })
    } else {
      // exibir mensagem
    }
    onHideDialogAddNew()
  }

  const pathOnEditFn = () => {
    const oid = _.get(props, 'oidRecord', null)
    if (oid) {
      const idValue = _.get(props, 'value', null)
      const documento = _.get(idValue, 'id', '')
      if (documento.length === 14) {
        return `${routes.PATH_PESSOA_JURIDICA}/${oid}`
      }
      return `${routes.PATH_PESSOA_FISICA}/${oid}`
    }
  }

  const resolveDisplayValue = () => {
    const idValue = _.get(props, 'value', null)
    return _.get(idValue, 'value', null)
  }

  return (
    <React.Fragment>
      {getDialogAddNew()}
      <LtsLookup
        label={props.label}
        value={resolveDisplayValue()}
        name={props.name}
        field={props.field}
        history={props.history}
        autoCompleteTemplate={getTemplateDropDownPessoa}
        onKeyPress={onKeyPress}
        onComplete={onKeyPress}
        onInputFilter={props.onInputFilter || onInputFilter}
        pathOnEditFn={pathOnEditFn}
        header={'Responsável'}
        columns={columns}
        onResolvingColumn={onResolvingColumn}
        onChange={props.onChange}
        filters={filters}
        setFilters={setFilters}
        showAddButton={true}
        onClickAddButton={onClickAddButton}
        loadDataFn={loadDataFn}
        resolveFilters={resolveFilters}
        showWhatsAppButton={props.showWhatsAppButton}
        onClickWhatsAppButton={props.onClickWhatsAppButton}
      />
    </React.Fragment>
  )
}
